var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoFraxswap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 283.46 283.46",
    style: {
      enableBackground: "new 0 0 283.46 283.46"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.fs0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "fs0",
    d: "M141.73,283.46c-19.13,0-37.69-3.75-55.17-11.14c-16.88-7.14-32.03-17.36-45.05-30.37 c-13.01-13.01-23.23-28.17-30.37-45.05C3.75,179.42,0,160.86,0,141.73s3.75-37.69,11.14-55.17c7.14-16.88,17.36-32.03,30.37-45.05 C54.53,28.5,69.68,18.28,86.56,11.14C104.04,3.75,122.6,0,141.73,0s37.69,3.75,55.17,11.14c16.88,7.14,32.03,17.36,45.05,30.37 c13.01,13.01,23.23,28.17,30.37,45.05c7.39,17.48,11.14,36.04,11.14,55.17s-3.75,37.69-11.14,55.17 c-7.14,16.88-17.36,32.03-30.37,45.05c-13.01,13.01-28.17,23.23-45.05,30.37C179.42,279.72,160.86,283.46,141.73,283.46z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 141.73,
    cy: 141.73,
    r: 134.22
  })), /*#__PURE__*/React.createElement("path", {
    className: "fs0",
    d: "M212.43,141.73c0-14.38-4.32-27.76-11.72-38.94l21.95-21.95L202.92,61.1l-21.89,21.89 c-11.24-7.55-24.76-11.96-39.29-11.96c-14.38,0-27.76,4.32-38.94,11.72L80.84,60.8L61.1,80.54l21.89,21.89 c-7.55,11.24-11.96,24.76-11.96,39.29c0,14.38,4.32,27.76,11.72,38.94L60.8,202.62l19.74,19.74l21.89-21.89 c11.24,7.55,24.76,11.96,39.29,11.96c14.38,0,27.76-4.32,38.94-11.72l21.96,21.96l19.74-19.74l-21.89-21.89 C208.02,169.78,212.43,156.26,212.43,141.73z M98.96,141.73c0-23.59,19.19-42.78,42.78-42.78s42.78,19.19,42.78,42.78 s-19.19,42.78-42.78,42.78S98.96,165.32,98.96,141.73z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoFraxswap);
export default __webpack_public_path__ + "static/media/logo_fraxswap.c11dd7bec9e9eda72b9003acbab4307b.svg";
export { ForwardRef as ReactComponent };